import "../../../../index80.css";
import { jsxs as n, Fragment as m, jsx as e } from "react/jsx-runtime";
import { i as D } from "../../../../type-BFTbooL7.js";
import { _ as f } from "../../../../cs-piwRuCFZ.js";
import l from "../../../TextOutput/index.js";
import p from "../../../Tooltip/index.js";
import { C as o } from "../../../../common-UUpiO33D.js";
const T = "_timeline-item_1g3u0_1", k = "_timeline-progress_1g3u0_8", y = "_today-marker_1g3u0_17", v = "_start-date-marker_1g3u0_23", M = "_end-date-marker_1g3u0_30", a = {
  timelineItem: T,
  timelineProgress: k,
  todayMarker: y,
  startDateMarker: v,
  endDateMarker: M
};
function b(d) {
  const {
    className: c,
    startDate: r,
    endDate: i,
    dateRange: t
  } = d;
  if (D(t) || !o(r) || !o(i))
    return null;
  const s = t.end.getTime() - t.start.getTime(), g = 1 - (t.end.getTime() - new Date(r).getTime()) / s, u = (t.end.getTime() - new Date(i).getTime()) / s, _ = 1 - (t.end.getTime() - (/* @__PURE__ */ new Date()).getTime()) / s;
  return /* @__PURE__ */ n(m, { children: [
    /* @__PURE__ */ n("div", { className: f(a.timelineItem, c), children: [
      /* @__PURE__ */ e("div", { className: a.startDateMarker }),
      /* @__PURE__ */ e("div", { className: a.endDateMarker }),
      /* @__PURE__ */ e(
        "div",
        {
          className: a.todayMarker,
          style: {
            left: `${100 * _}%`
          }
        }
      ),
      /* @__PURE__ */ e(
        "div",
        {
          className: a.timelineProgress,
          style: {
            left: `${100 * g}%`,
            right: `${100 * u}%`
          }
        }
      )
    ] }),
    /* @__PURE__ */ e(
      p,
      {
        description: /* @__PURE__ */ n(m, { children: [
          /* @__PURE__ */ e(
            l,
            {
              valueType: "date",
              label: "Start Date",
              value: r
            }
          ),
          /* @__PURE__ */ e(
            l,
            {
              label: "End Date",
              value: i,
              valueType: "date"
            }
          )
        ] })
      }
    )
  ] });
}
export {
  b as default
};
